<!-- feedback -->
<template>
  <div>
    <div class="dis-40">
      <component :is="componentId"
                 :feedbackDetail="feedbackDetail"></component>
    </div>
    <div v-if="appDetail.statu === 'COMPLETE'">
      <div class="evaluate-mentor">
        <div>
          <evaluate-mentor :appDetail="appDetail"
                           :isPackageId="isPackageId"
                           @on-success="handleSubEvaluate">
          </evaluate-mentor>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// api
import { getFeedbackDetail } from '@/api/feedback'
// components
import Feedback1 from './feedback1'
import Feedback2 from './feedback2'
import Feedback3 from './feedback3'
import Feedback78 from './feedback78'
import FeedbackInterview from './feedback-interview'
import EvaluateMentor from './evaluate-mentor'
export default {
  name: 'app-project-feedback-main',
  props: ['appDetail', 'isPackageId'],
  components: {
    Feedback1,
    Feedback2,
    Feedback3,
    Feedback78,
    EvaluateMentor,
    FeedbackInterview
  },
  data () {
    return {
      componentId: '',
      feedbackDetail: {}
    }
  },
  computed: {},
  mounted () {
    this.mapComponents()
  },
  methods: {
    mapComponents () {
      let modules = this.appDetail.module
      let name = ''
      switch (modules) {
        case 'MODULE_1':
          name = Feedback1
          break
        case 'MODULE_2':
          name = Feedback2
          break
        case 'MODULE_3':
          name = Feedback3
          break
        case 'MODULE_7':
        case 'MODULE_8':
          name = Feedback78
          break
        case 'INTERVIEW':
          name = FeedbackInterview
          break
      }
      this.componentId = name
      this.getFeedbackDetail()
    },
    // 获取feedback详情
    getFeedbackDetail () {
      getFeedbackDetail({
        id: this.appDetail.id
      }).then(res => {
        this.feedbackDetail = res.data.model
      })
    },
    // 提交评价成功
    handleSubEvaluate () {
      this.$emit('on-evaluate-suc')
    }
  },
  watch: {
    appDetail () {
      this.mapComponents()
    }
  }
}
</script>
<style lang='less' scoped>
.evaluate-mentor {
  background: #fff;
  padding: 24px 0 32px;
  > div {
    width: 1280px;
    padding-left: 160px;
    margin: 0 auto;
  }
}
</style>
